export const contactsData = {
    email: 'elsaheitz01@gmail.com',
    address: '',
    sheetAPI: 'https://sheetdb.io/api/v1/8d0077omqa1xx'
}
